var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInformation = function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff7a00",
    "data-name": "Group 5133"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 1.231A6.769 6.769 0 1 0 14.769 8 6.769 6.769 0 0 0 8 1.231M0 8a8 8 0 1 1 8 8 8 8 0 0 1-8-8",
    "data-name": "Path 19005"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 11.489a.616.616 0 0 0 .616-.616V7.588a.616.616 0 1 0-1.232 0v3.285a.616.616 0 0 0 .616.616",
    "data-name": "Path 19006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.821 5.129A.821.821 0 1 0 8 5.95a.821.821 0 0 0 .821-.821",
    "data-name": "Path 19007"
  }))));
};
export default SvgInformation;